// extracted by mini-css-extract-plugin
export default {"root":"DetailsV2_root__x9hBW"};